import { FORM_FIELDS, FORM_FIELDS_NAMES } from './site-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

export const NEW_SITE_CUSTOMER_INFO_INPUTS = ({ t, link }): IFormInputProps[] => {
	return [
		{
			key: FORM_FIELDS.CONTACT_NAME,
			fieldName: FORM_FIELDS.CONTACT_NAME,
			placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.CONTACT_NAME)}`,
			label: t(FORM_FIELDS_NAMES.CONTACT_NAME),
			inputType: InputType.Text,
			required: true,
			fakeInputAdditionalClass: 'col-md-4',
			// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
			autoComplete: 'name',
		},
		{
			key: FORM_FIELDS.URL,
			fieldName: FORM_FIELDS.URL,
			placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.URL)}`,
			label: t(FORM_FIELDS_NAMES.URL),
			inputType: InputType.Website,
			fakeInputAdditionalClass: 'col-md-4 fc-text-overflow',
			required: true,
			link: link,
			linkAdditionalClassName: 'fc-text-overflow',
			autoComplete: 'url',
		},
		{
			key: FORM_FIELDS.PHONE,
			fieldName: FORM_FIELDS.PHONE,
			placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.PHONE)}`,
			label: t(FORM_FIELDS_NAMES.PHONE),
			inputType: InputType.Phone,
			defaultCountry: 'US',
			fakeInputAdditionalClass: 'col-md-4',
			required: true,
			autoComplete: 'tel',
		},
		{
			key: FORM_FIELDS.EMAIL,
			fieldName: FORM_FIELDS.EMAIL,
			placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(FORM_FIELDS_NAMES.EMAIL)}`,
			label: t(FORM_FIELDS_NAMES.EMAIL),
			inputType: InputType.Text,
			fakeInputAdditionalClass: 'col-md-4',
			required: true,
			autoComplete: 'email',
		}
	];
};
